export enum UnsampledTimeCorrectionType {
    AssumeZero = 0,
    AssumeUniform = 1,
    AssumeIdentifiedValue = 2,
    Instantaneous = 3,
    FullShiftConsecutive = 4,
}